import styled from 'styled-components';
import { Button, Layout, Space } from 'antd';

const { Content } = Layout;

export const ConfigNav = styled.div`
  .ant-tabs-top > .ant-tabs-nav {
    margin: 0px;
    background-color: white;
    border-top: 1px solid #748aa1;
  }
  .ant-tabs-nav-list {
    margin-left: 32px;
    margin-right: 8px;
  }
`;

export const PageContent = styled(Content)`
  display: flex;
  flex-direction: column;
  background-color: white;
  margin: 20px;
  padding: 20px;
  border-radius: 4px;
`;

export const TabContent = styled(Content)`
  display: flex;
  flex-direction: row;
  margin: 20px 20px 0 20px;
  padding: 0px 10px;
`;

export const PageSpace = styled(Space)`
  width: 100%;
  background-color: #bec3ca;
`;

export const TabButton = styled(Button)`
  width: 100px;
  margin-right: 20px;
  color: #3e7ad3;
  border: 1px solid #3e7ad3;
  border-radius: 100px !important;
  background: transparent;
`;

export const SummaryHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const SummaryHeader = styled.div`
  display: flex;
  align-self: flex-end;
  margin-bottom: 10px;
`;
